// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import axios from 'axios' 
import VueAxios from 'vue-axios' //异步请求
import VueWechatTitle from  'vue-wechat-title'
import VueAwesomSwiper from 'vue-awesome-swiper'
import 'font-awesome/css/font-awesome.min.css'

Vue.use(ElementUI)
Vue.use(VueAxios,axios)//全局使用 this.axios
Vue.use(VueWechatTitle)
Vue.use(VueAwesomSwiper)
Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js